import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getHomeData } from "../api/home";
import { toImagePath, toPascalCase } from "../utils/globalFunctions";

const Intro = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [intro, setIntro] = useState({intro: {enable: false}});
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        const getData = async () => {
            setIsLoading(true);
            try {
                const response = await getHomeData();
            setIntro(response);
                if (!response.intro?.enable) {
            navigate("/home");
                }

            } catch (error) {
                console.error("Error fetching home data:", error);
            } finally {
                setIsLoading(false);
            }
        };
        getData();
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [navigate]);
    
    // useEffect(() => {
    //     if (!intro.intro?.enable) {
    //         console.log("Intro is useeffect");
    //         navigate("/home");
    //     }
    // }, [intro]);
    
    // if (!intro.intro?.enable) {
    //     return null;
    // }

    return (
        <div className="flex justify-center bg-yellow-100">
            {isLoading ? <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50" /> : 
            <div className="relative w-full h-screen">
                <img
                    className="w-full h-screen object-contain"
                    src={intro.intro && (isMobile ? intro.intro.introimagemobile?.path : intro.intro.introImage?.path) ? `${isMobile ? toImagePath(intro.intro.introimagemobile?.path) : toImagePath(intro.intro.introImage?.path)}` : ""}
                    alt="Background"
                />
                <div className="sm:absolute w-full flex flex-row justify-around sm:justify-around md:justify-around items-center">
                    <div className="sm:absolute bottom-0 xs:bottom-10 sm:bottom-0 xl:bottom-36 2xl:bottom-0 w-full flex justify-center lg:justify-center items-center px-4 pr-5 sm:pr-0 md:pr-2  pb-2 lg:pb-4">
                        <button
                            className="mt-2 intro-button w-[40%] sm:w-[40%] md:w-[40%] lg:w-[30%] xl:w-[%] bg-[#272974] text-white text-xs sm:text-sm md:text-lg font-bold lg:py-3 lg:px-6 rounded-full shadow-lg hover:bg-[#313385] focus:outline-none focus:ring-4 focus:ring-yellow-300 focus:ring-offset-2 transition duration-300 ease-in-out transform hover:scale-105"
                            onClick={() => navigate("/home")}
                            aria-label="Enter the website"
                        >
                            เข้าสู่เว็บไซต์ สกมช.
                        </button>
                    </div>
                </div>
            </div>
        }
        </div>
    );
};

export default Intro;